import React from 'react';
import PatientTableSelectionRealtime from '../select-patient';
import { Button, Divider, Typography } from 'antd';
import { ChevronRight, ChevronLeft, Shell } from 'lucide-react';
const { Title, Text } = Typography;
interface BlindSweepPatientProps {
  selectedRow: any; // Adjust type as needed
  createBlindStudyLoading: boolean;
  setShowPatientModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedRow: React.Dispatch<React.SetStateAction<any>>;
  onNext?: () => void;
  onPrevious?: () => void;
}

function BlindSweepPatient({
  selectedRow,
  setShowPatientModal,
  setSelectedRow,
  onNext,
  onPrevious,
  createBlindStudyLoading,
}: BlindSweepPatientProps) {
  return (
    <div className="w-full h-full flex flex-col dui-bg-base-100 border-2 border-blue-100">
      <div className="dui-card h-full">
        <div className="dui-card-body p-0 h-full">
          <div className="bg-gradient-to-r from-blue-50 to-white p-4 sm:p-6 border-b border-blue-100 flex">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full">
              <div>
                <Title
                  level={3}
                  className="text-blue-800 m-0 text-xl sm:text-2xl md:text-3xl"
                >
                  Medical BlindSweep Imaging System
                </Title>
                <Text className="text-blue-600 text-sm sm:text-base">
                  Select a patient to begin the process
                </Text>
              </div>
              <div className="flex gap-2 sm:gap-4">
                <Button
                  type="default"
                  size="large"
                  onClick={onPrevious}
                  className="border-blue-300 text-blue-600 hover:text-blue-700 hover:border-blue-400 flex items-center text-sm sm:text-base"
                >
                  <ChevronLeft className="mr-2 h-4 w-4" /> Previous
                </Button>
                <Button
                  type="primary"
                  size="large"
                  onClick={onNext}
                  disabled={createBlindStudyLoading}
                  className="bg-blue-600 hover:bg-blue-700 border-blue-700 flex items-center text-sm sm:text-base"
                >
                  Start Sweeping <Shell className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
          <div className="flex min-h-0 flex-1">
            <PatientTableSelectionRealtime
              showPatientModal={true}
              setShowPatientModal={setShowPatientModal}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              modal={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlindSweepPatient;
